import { collection, getDocs, doc, getDoc, setDoc, updateDoc } from 'firebase/firestore';
import { db } from './config';

// Tüm şubeleri getir
export const getAllBranches = async () => {
    try {
        const branchesCollection = collection(db, 'branches');
        const branchSnapshot = await getDocs(branchesCollection);
        return branchSnapshot.docs.map(doc => ({
            id: doc.id,
            ...doc.data()
        }));
    } catch (error) {
        console.error("Şubeler alınırken hata:", error);
        return [];
    }
};

// Belirli bir şubeyi getir
export const getBranchById = async (branchId) => {
    try {
        const branchRef = doc(db, 'branches', branchId);
        const branchSnap = await getDoc(branchRef);

        if (branchSnap.exists()) {
            return {
                id: branchSnap.id,
                ...branchSnap.data()
            };
        } else {
            return null;
        }
    } catch (error) {
        console.error("Şube bilgisi alınırken hata:", error);
        return null;
    }
};

// Kullanıcının şube tercihini güncelle
export const updateUserBranch = (userId, branchId, setUser) => {
    // localStorage'a şube bilgisini kaydet
    localStorage.setItem("selectedBranch", branchId);


    // Kullanıcı context'ini güncelle (eğer setUser fonksiyonu verilmişse)
    if (setUser) {
        setUser(prevUser => ({
            ...prevUser,
            selectedBranch: branchId
        }));
    }

    return true;
};

// Şube koleksiyon adını al
export const getCollectionName = (type) => {
    const selectedBranch = localStorage.getItem("selectedBranch");

    switch (type) {
        case 'users':
            return selectedBranch === "vvG8ruigVsJChISbvnNM" ? "users-2" : "users";
        case 'orders':
            return selectedBranch === "vvG8ruigVsJChISbvnNM" ? "orders-2" : "orders";
        case 'images':
            return selectedBranch === "vvG8ruigVsJChISbvnNM" ? "images-2" : "images";
        default:
            return type;
    }
};